import React, {useEffect,useState, useContext, useRef} from 'react';
import {FormValidator, useFormValidator, Inputs, useTariffableInputs} from 'coaz-ui';
import client from '../client';

const AddUserType = ({params, submitRef, setLoading, setEnableSubmit}) => {
    const [userType,setUserType] = useState({});
    const minWidth = 240;
    const {request,errorMessage} = client;
    const submit = async (e) => {
        try {
            const response = await request('POST', 'user-types', userType);

            if (response && response.ref) {
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            return {
                message: errorMessage(error)
            };
        }
    };

    const [register,handleChange,handleSubmit,errors] = useFormValidator(submit);

    const {inputs} = useTariffableInputs(userType,setUserType,request,handleChange,register,errors);


    useEffect(() => {
        if (handleSubmit) {
            submitRef.current = { submit: handleSubmit };
            setEnableSubmit(true);
        } else {
            submitRef.current = null;
            setEnableSubmit(false);
        }

        return () => {
            submitRef.current = null;
        };
    }, [handleSubmit]);

    useEffect(() => {
        setLoading && setLoading(false);
    },[]);

    return (
        <FormValidator>
            <div className='w-full h-auto shrink-0'>
                <Inputs inputs={inputs} minWidth={minWidth} onSubmit={handleSubmit}/>
            </div>
        </FormValidator>
      )
}

export default AddUserType